// TeamOverviewMenu.jsx
import { useId } from "react";
import { motion } from "framer-motion";

export default function TeamOverviewMenu({ value, onChange, isDark, tabs }) {
  const layoutId = useId();
  const keys = Object.keys(tabs);
  const gridCols =
    keys.length === 4 ? "grid-cols-4" :
    keys.length === 3 ? "grid-cols-3" :
    keys.length === 2 ? "grid-cols-2" : "grid-cols-1";

  return (
    <div className="relative w-full max-w-4xl mx-auto">
      <div className={`grid ${gridCols} gap-2 rounded-xl p-1 
        ${isDark ? "bg-gray-800/70 ring-1 ring-white/10" : "bg-white/70 ring-1 ring-black/10"} 
        backdrop-blur`}>
        {keys.map((k) => {
          const active = value === k;
          const { label, Icon, gradient } = tabs[k];
          return (
            <button
              key={k}
              onClick={() => onChange(k)}
              className="relative group h-11 rounded-lg overflow-hidden"
            >
              {active && (
                <motion.div
                  layoutId={`fancyTab-${layoutId}`}
                  className="absolute inset-0 rounded-lg"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                >
                  <div className={`absolute inset-0 ${gradient ?? "bg-gradient-to-r from-indigo-600 via-fuchsia-500 to-pink-500"} opacity-90`} />
                </motion.div>
              )}
              <div className={`relative z-10 flex items-center justify-center gap-2 h-full px-3 text-sm font-medium
                ${active ? "text-white" : (isDark ? "text-gray-300" : "text-gray-700")}`}>
                {Icon && <Icon className={`h-4 w-4 ${active ? "opacity-100" : "opacity-70 group-hover:opacity-100"}`} />}
                <span>{label}</span>
              </div>
              {!active && (
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity 
                  bg-gradient-to-r from-indigo-500/10 via-fuchsia-500/10 to-pink-500/10" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
